import {
    Breadcrumbs,
    Button,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material"; import React, { useContext, useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";

import { emphasize, styled } from '@mui/material/styles';
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MyContext } from "../../App";
import { deleteData, fetchDataFromApi } from "../../utils/api";

//breadcrump code
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
});


const Material = () => {

    const [materialData, setMaterialData] = useState([])
    const [openDelete, setOpenDelete] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const context = useContext(MyContext)

    useEffect(() => {
        window.scrollTo(0, 0)

        context.setProgress(20)

        fetchDataFromApi('/api/material').then(res => {
            setMaterialData(res)
            context.setProgress(100)
        })
    }, [])


    const handleDeleteClick = (id) => {
        setSelectedId(id);
        setOpenDelete(true);
    };

    // ================= Confirm delete =================
    const confirmDelete = () => {
        context.setProgress(40);

        deleteData(`/api/material/${selectedId}`)
            .then(() => {
                context.setProgress(100);

                context.setAlertBox({
                    open: true,
                    error: true,
                    msg: "Material Deleted!",
                });

                fetchDataFromApi("/api/material").then((res) => {
                    setMaterialData(res);
                });

                setOpenDelete(false);
            })
            .catch((err) => {
                console.error("Error deleting material:", err);
            });
    };

    return (
        <>
            <div className="right-content w-100">
                <div className="card shadow border-0 w-100 flex-row p-4">
                    <h5 className="mb-0">Material List</h5>
                    <div className="ml-auto d-flex align-items-center">
                        <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
                            <StyledBreadcrumb
                                component="a"
                                href="#"
                                label="Dashboard"
                                icon={<HomeIcon fontSize="small" />}
                            />
                            <StyledBreadcrumb
                                label="Material"
                                deleteIcon={<ExpandMoreIcon />}
                            />
                        </Breadcrumbs>

                        <Link to="/Material/add"><Button className="btn-blue ml-3 pl-3 pr-3">Add Material</Button></Link>
                    </div>
                </div>



                <div className="card shadow border-0 p-3 mt-4">
                    <div className="table-responsive mt-3">
                        <table className="table table-bordered v-align">
                            <thead className="thead-dark">
                                <tr>
                                    <th>MATERIAL</th>
                                    <th>ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    materialData?.materials?.length > 0 ? (materialData?.materials?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.name}</td>
                                                <td>
                                                    <div className="actions d-flex align-items-center">
                                                        <Button
                                                            className="error"
                                                            color="error"
                                                            onClick={() => handleDeleteClick(item._id)}
                                                        >
                                                            <MdDelete />
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>

                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="text-center">
                                                No Top Material Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
                            <DialogTitle>Delete Material</DialogTitle>
            
                            <DialogContent>
                                Are you sure you want to delete this Material?
                            </DialogContent>
            
                            <DialogActions>
                                <Button onClick={() => setOpenDelete(false)}>Cancel</Button>
            
                                <Button
                                    color="error"
                                    variant="contained"
                                    startIcon={<MdDelete />}
                                    onClick={confirmDelete}
                                >
                                    Delete
                                </Button>
                            </DialogActions>
                        </Dialog>
        </>
    )
}

export default Material;